// extracted by mini-css-extract-plugin
export default {"zoomModal":"I3-z","image":"J3-z","button":"K3-z","isOverlayShown":"L3-z"};